// web/src/lib/webrtc/factory.ts

import type { WebRTCCallAdapter } from "./types";

export async function createWebRTCAdapter(provider: "twilio" | "3cx"): Promise<WebRTCCallAdapter> {
  switch (provider) {
    case "twilio": {
      // Dynamic import to code-split — only loads when Twilio is the active provider
      const { TwilioWebRTCAdapter } = await import("./twilio-adapter");
      return new TwilioWebRTCAdapter();
    }
    case "3cx": {
      const { ThreeCXWebRTCAdapter } = await import("./threecx-adapter");
      return new ThreeCXWebRTCAdapter();
    }
    default:
      throw new Error(`Unknown WebRTC provider: ${provider}`);
  }
}
